import React from 'react'
import { Link, To } from 'react-router-dom'

export interface INavItemProps
  extends Omit<
    React.DetailedHTMLProps<React.LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>,
    'onClick' | 'id'
  > {
  id: string
  to: To
  children?: React.ReactNode
  disabled?: boolean
  active?: boolean
  hidden?: boolean
  onClick?: (value: INavItemProps) => Promise<void> | void
}

export const NavItem = ({
  to,
  className,
  disabled,
  active,
  hidden,
  children,
  onClick: handleClick,
  ...props
}: INavItemProps): React.ReactElement | null => {
  const navItemClassNames: string[] = ['nav-item', className || '']
  const navLinkClassNames: string[] = ['nav-link']
  if (disabled) navLinkClassNames.push('disabled')
  if (active) navLinkClassNames.push('active')
  if (hidden) return null
  return (
    <li {...props} className={navItemClassNames.join(' ').trim()}>
      <Link
        to={to}
        className={navLinkClassNames.filter(Boolean).join(' ').trim()}
        onClick={async () => {
          await handleClick?.({
            to,
            className,
            disabled,
            children,
            onClick: handleClick,
            ...props,
          })
        }}
      >
        {children}
      </Link>
    </li>
  )
}
